import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";
import { IRetornoObterSolicitacoesDoUsuario } from "./ObterSolicitacoesDoUsuario";

export const ObterSolicitacoesPendentesSolicitadasPeloUsuario = async (
  CurrentPage: number
): Promise<IRetornoObterSolicitacoesDoUsuario> => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<IRetornoObterSolicitacoesDoUsuario>(
      `/solicitacaosenhapendenteporusuario`,
      { params: { token, CurrentPage, Limit: 10 } }
    );

    return data;
  } catch (error) {
    throw new ApiException(
      error,
      "Erro ao buscar solicitações pendentes solicitadas pelo usuário"
    );
  }
};